import {Skeleton} from '@dropbox/dig-components/skeleton';
import {Text} from '@dropbox/dig-components/typography';
import {Box} from '@dropbox/dig-foundations';
import {t} from 'i18next';

/**
 * The knowledge card's one-sentence answer: a placeholder line while it
 * loads, then the sentence. Nothing when there's none (the article doesn't
 * answer, or the call failed); the rest of the card stays as it was.
 */
export const InstantAnswerSummaryLine = ({
  summary,
  isLoading,
}: {
  summary: string | null;
  isLoading: boolean;
}) => {
  if (summary) {
    return <Text>{summary}</Text>;
  }
  if (!isLoading) {
    return null;
  }
  return (
    <Box role="status" aria-label={t('search_instant_answer_summary_loading')}>
      <Skeleton.Text width={330} />
    </Box>
  );
};
